<div class="provider-autocomplete">
	<label *ngIf="label" class="block text-[12px] font-medium text-gray-700 mb-1">
		{{ label }}
		<span *ngIf="required" class="text-red-500">*</span>
	</label>

	<!-- Toggle pour le type de prestataire (seulement pour REFUND_REQUEST) -->
	<div *ngIf="messageType === 'REFUND_REQUEST'" class="mb-3">
		<div class="flex bg-gray-100 rounded-lg p-1 w-fit">
			<button type="button" (click)="setProviderSearchType('conventionnes')"
				[class]="providerSearchType === 'conventionnes' ? 'bg-white text-primary shadow-sm' : 'text-gray-600 hover:text-gray-800'"
				class="px-3 py-1 text-xs font-medium rounded-md transition-all duration-200">
				Conventionnés
			</button>
			<button type="button" (click)="setProviderSearchType('non_conventionnes')"
				[class]="providerSearchType === 'non_conventionnes' ? 'bg-white text-primary shadow-sm' : 'text-gray-600 hover:text-gray-800'"
				class="px-3 py-1 text-xs font-medium rounded-md transition-all duration-200">
				Non conventionnés
			</button>
		</div>
	</div>

	<div class="relative">
		<!-- Champ de recherche -->
		<div class="relative">
			<input type="text" [placeholder]="placeholder" [disabled]="disabled" [value]="searchTerm"
				(input)="onSearchInput($event)" (focus)="onFocus()" (blur)="onBlur()"
				class="!text-sm w-full px-3 py-2 pl-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
				[class.bg-gray-100]="disabled" [class.cursor-not-allowed]="disabled" />

			<!-- Icône de recherche -->
			<div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
				<lucide-icon [img]="Search" class="w-4 h-4 text-gray-400"></lucide-icon>
			</div>

			<!-- Bouton de suppression -->
			<button *ngIf="selectedProvider && !disabled" type="button" (click)="clearSelection()"
				class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
				<lucide-icon [img]="X" class="w-4 h-4"></lucide-icon>
			</button>
		</div>

		<!-- Dropdown des résultats -->
		<div *ngIf="isOpen && (filteredProviders.length > 0 || loading)"
			class="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
			<!-- Loading state -->
			<div *ngIf="loading" class="p-4 text-center text-gray-500">
				<div class="animate-spin rounded-full h-4 w-4 border-b-2 border-primary mx-auto"></div>
				<p class="text-xs mt-2">Recherche en cours...</p>
			</div>

			<!-- Résultats -->
			<div *ngIf="!loading && filteredProviders.length > 0">
				<div *ngFor="let provider of filteredProviders; trackBy: trackByProvider"
					(click)="selectProvider(provider)"
					class="px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0">
					<div class="flex items-center gap-3">
						<!-- Icône du type de prestataire -->
						<div class="flex-shrink-0">
							<span class="text-lg">{{ getProviderIcon(provider.type) }}</span>
						</div>

						<!-- Informations du prestataire -->
						<div class="flex-1 min-w-0">
							<div class="flex items-center justify-between">
								<p class="!text-sm font-medium text-gray-900 truncate">
									{{ provider.name }}
								</p>
								<span class="!text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
									{{ getProviderTypeLabel(provider.type) }}
								</span>
							</div>
							<!-- Prestataire Connecté indicator -->
							@if (provider.eyoneUser) {
							<div class="flex items-center gap-1 mt-1"
								[title]="'Ce prestataire échange automatiquement vos informations avec votre {{getProductName()}} pour faciliter votre prise en charge.'">
								<span class="text-xs text-green-600 flex items-center gap-1">
									<lucide-icon [img]="CircleIcon" [size]="8"
										class="fill-green-500 text-green-500"></lucide-icon>
									Prestataire Connecté
								</span>
							</div>
							}
						</div>
					</div>
				</div>
			</div>

			<!-- Aucun résultat -->
			<div *ngIf="!loading && filteredProviders.length === 0 && searchTerm.length >= 2"
				class="p-4 text-center text-gray-500">
				<p class="!text-sm">Aucun prestataire trouvé</p>
				<p class="!text-xs mt-1">Essayez avec d'autres termes de recherche</p>
			</div>

			<!-- Erreur -->
			<div *ngIf="error" class="p-4 text-center text-red-500">
				<p class="!text-sm">{{ error }}</p>
				<p class="!text-xs mt-1">Veuillez réessayer</p>
			</div>
		</div>
	</div>

	<!-- Message d'aide -->
	<p *ngIf="searchTerm.length === 0" class="!text-xs text-gray-500 mt-1">
		Tapez au moins 2 caractères pour commencer la recherche
	</p>
</div>